<template>
  <div v-if="src && srcset" class="relative">
    <MImage
      class="block h-full w-full object-cover object-top"
      :class="imageClass"
      :src="src"
      :srcset="srcset.length > 1 ? srcset.join(', ') : undefined"
      :low-src="lowSrc"
      :alt="image.alt"
      :lazy="lazy"
      sizes="auto"
    />
    <ImageCopyright v-if="!noCopyright && image.copyright" :copyright="image.copyright" />
  </div>
</template>

<script lang="ts" setup>
import type { GQLImage } from '@core/types/generated/image'

const props = withDefaults(
  defineProps<{
    image: GQLImage
    size?: {
      width?: number
      height?: number
    }
    imageClass?: string
    lazy?: boolean
    noCopyright?: boolean
  }>(),
  { lazy: true },
)

const lowSrc = computed(() => getLowSrc(props.image, props.size))
const srcset = computed(() => getSrcset(props.image, props.size))
const src = computed(() => srcset.value?.[0]?.split(' ')[0])
</script>
